import { IPlayer, PlayersAction } from './types';

export interface IPlayerState {
  all: IPlayer[];
  isFetching: boolean;
  error?: any;
}

const initialState: IPlayerState = {
  all: [],
  isFetching: false,
};

export const players = (state = initialState, action: PlayersAction) => {
  switch (action.type) {
    case 'PLAYERS/FETCH_ALL_REQUEST': {
      return {
        ...state,
        isFetching: true,
      };
    }
    case 'PLAYERS/FETCH_ALL_SUCCESS': {
      return {
        ...state,
        all: action.data,
        isFetching: false,
      };
    }
    case 'PLAYERS/FETCH_ALL_FAILURE': {
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
